import { IToastProps, Toaster } from "@blueprintjs/core";

const toaster = Toaster.create({
  position: "bottom",
});

export function showToast(props: IToastProps, key?: string) {
  return toaster.show(props, key);
}
